import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Container, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Feature } from "libs/security/authorization/FeatureAbility";
import { useResourceAbility, useFeatureAbility } from "libs/security/authorization/Permission";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import ProxyService from "libs/resources/proxy/ProxyService";
import CopyToClipboard from "legacy-components/form/action/CopyToClipboard";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Container>
          <Box>{children}</Box>
        </Container>
      )}
    </div>
  );
}

const useStyles = makeStyles(({ palette }) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    title: {
      marginBottom: "15px",
    },
    tabs: {
      marginBottom: "30px",
    },
    container: {
      marginBottom: "10px",
    },
    icon: {
      color: palette.text.primary,
    },
  })
);

interface ProxySingleEnvironmentsProps {
  proxy: any; // TODO: Define proper type
  onUpdate?: () => void;
}

export default function ProxySingleEnvironments(props: ProxySingleEnvironmentsProps) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [isShowEnvironmentHelper, toggleEnvironmentHelper] = useState(false);
  const [canShowResourceAuthorizer, setShowResourceAuthorizer] = React.useState<Record<string, boolean>>({});
  let gateways = useSelector((state: any) => state?.common?.gateway);
  const [, setApi] = useState<any>();

  const [isFormCompleted, setIsFormCompleted] = useState<boolean>();

  const onSuccess = () => {
    // TODO: Implement onSuccess logic
  };

  const getApiDetails = (api: any) => {
    // TODO: Implement getApiDetails logic
    return api;
  };

  const [response, { subscribe }] = useAsyncAction(
    () => ProxyService.forApi(props.proxy?.apiName),
    {
      mapFn: getApiDetails,
    }
  );

  useEffect(() => {
    // TODO: Implement effect logic
  }, [subscribe, isFormCompleted]);

  const [can] = useResourceAbility({
    resource: ({ Proxy }: any) => Proxy.deploy.environment["trimble-pre-prod"],
  });

  const [hasInvite] = useResourceAbility({
    resource: ({ TeamMembers }: any) => TeamMembers.invite,
  });

  useEffect(() => {
    // TODO: Implement effect logic
  }, [response.value, gateways, hasInvite?.create()]);

  const [canVerify] = useResourceAbility({
    resource: ({ Proxy }: any) => Proxy.verification.getStarted,
  });

  const hasFeature = useFeatureAbility({
    id: Feature.ApiVerification,
  });

  const CopyAPIName = (
    <CopyToClipboard size="small" edge="end" text={props.proxy?.apiName} />
  );

  return null; // TODO: Implement actual render logic
}
